import React, { memo, ReactElement, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import i18next from 'i18next';
import { fetchFromRestAPI } from '../../util/api';
import ConfirmationModal from '../ConfirmationModal';
import { AUTH0_ORGANIZATION_ID } from '../../config';

const AcceptAppointment = (): ReactElement => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { appointmentId } = useParams<{ appointmentId: string }>();
  const handleAcceptAppointment = async (): Promise<void> => {
    setIsLoading(true);
    try {
      await fetchFromRestAPI(`/api/v1/appointment/public/therapist/confirm/${appointmentId}?tenant=${AUTH0_ORGANIZATION_ID}`, {
        method: 'POST',
      });
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Error accept appointment', error);
      window.close();
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="bg-white d-flex flex-row justify-content-center w-100 vh-100">
      <div className="d-flex flex-column justify-content-center align-items-center">
        <ConfirmationModal
          disableButton={isLoading}
          show={true}
          title={i18next.t('createAppointmentForm.acceptModal.title')}
          body={
            <>
              <p>{i18next.t('createAppointmentForm.acceptModal.body')}</p>
            </>
          }
          buttonPositive={i18next.t('createAppointmentForm.labels.accept')}
          buttonNegative={i18next.t('generic.cancel')}
          onPositive={handleAcceptAppointment}
          onNegative={() => window.close()}
        />
      </div>
    </div>
  );
};

export default memo(AcceptAppointment);
